import difference from 'lodash/difference'

import { InvoiceTotalPriceColumns } from '../enums/invoiceTotalPriceColumns'
import type { InvoiceLineColumn } from '../types/invoiceLineColumn'

const totalPriceColumnNames: InvoiceLineColumn[] = ['total', 'netTotal']

const columnNamesByTotalPriceColumns: Record<InvoiceTotalPriceColumns, InvoiceLineColumn[]> = {
  [InvoiceTotalPriceColumns.Both]: ['total', 'netTotal'],
  [InvoiceTotalPriceColumns.Gross]: ['total'],
  [InvoiceTotalPriceColumns.Net]: ['netTotal'],
}

export const replaceInvoiceTotalPriceColumns = <Column extends string>(
  columns: Column[],
  totalPriceColumns: InvoiceTotalPriceColumns,
): (Column | InvoiceLineColumn)[] => {
  return [
    ...difference<Column | InvoiceLineColumn>(columns, totalPriceColumnNames),
    ...columnNamesByTotalPriceColumns[totalPriceColumns],
  ]
}
